export const navToExternalUrl = (event, url) => {
  event?.preventDefault();
  window.open(url, '_blank');
}

export const getPlatform = (): string => {
  const userAgent = navigator.userAgent || navigator.vendor;

  if (/android/i.test(userAgent)) {
    return 'Android';
  }

  if (/iPad|iPhone|iPod/.test(userAgent)) {
    return 'iOS';
  }

  if (/Macintosh|MacIntel|MacPPC|Mac68K/.test(userAgent)) {
    return 'Mac';
  }

  if (/Win32|Win64|Windows|WinCE/.test(userAgent)) {
    return 'Windows';
  }

  return 'Other';
}
